export default "__VITE_ASSET__20f801c5__"